import { json, postBiz, rows } from '../core/coreapi';
import { BieRecordId } from './bieonboardingworkbench.models';
import {
  normalizeImportItemId,
  normalizeLoadSessionId,
  normalizeImportId,
} from './bieonboarding.normalize';

const SERVICE = 'biegovernancedecision';

export type BieGovernanceReviewAction = 'REVIEW' | 'APPROVE' | 'REJECT';

export interface IBieGovernanceDecision {
  rid?: BieRecordId;
  rix?: string;
  imi?: BieRecordId;
  iti?: BieRecordId;
  ruc?: string;
  run?: string;
  dri?: BieRecordId;
  drc?: string;
  drn?: string;
  ssc?: string;
  ssn?: string;
  vlr?: number | null;
  mnv?: number | null;
  mxv?: number | null;
  fsy?: number | null;
  rqr?: string;
  rqe?: string;
  rby?: BieRecordId;
  rat?: string;
  rvn?: string;
  vby?: BieRecordId;
  vat?: string;
  aex?: number;
  rea?: number;
  mey?: number;
  rta?: number;
  exi?: Record<string, unknown>;
  sts?: number;
  stp?: string;
}

export interface IBieGovernanceDecisionResult {
  rid?: BieRecordId;
  stp?: string;
  decision?: IBieGovernanceDecision;
  nextaction?: Record<string, unknown>;
}

export async function requestBieGovernanceDecision(
  importItemId: BieRecordId,
  reason: string,
  evidence: string,
): Promise<IBieGovernanceDecisionResult> {
  return json(await postBiz({
    s: SERVICE,
    a: 'request',
    iti: normalizeImportItemId(importItemId),
    rsn: reason,
    evd: evidence,
  })) as IBieGovernanceDecisionResult;
}

export async function reviewBieGovernanceDecision(
  decisionId: BieRecordId,
  actionCode: BieGovernanceReviewAction,
  notes: string,
  stamp: string,
): Promise<IBieGovernanceDecisionResult> {
  return json(await postBiz({
    s: SERVICE,
    a: 'review',
    rid: decisionId,
    act: actionCode,
    nts: notes,
    stp: stamp,
  })) as IBieGovernanceDecisionResult;
}

export async function withdrawBieGovernanceDecision(
  decisionId: BieRecordId,
  reason: string,
  stamp: string,
): Promise<IBieGovernanceDecisionResult> {
  return json(await postBiz({
    s: SERVICE,
    a: 'withdraw',
    rid: decisionId,
    rsn: reason,
    stp: stamp,
  })) as IBieGovernanceDecisionResult;
}

export async function fetchBieGovernanceDecisions(params: {
  loadSessionId?: BieRecordId | null;
  importId?: BieRecordId | null;
  importItemId?: BieRecordId | null;
  driverId?: BieRecordId | null;
  stateCode?: string | null;
  pageOffset?: number;
  pageLimit?: number;
}): Promise<IBieGovernanceDecision[]> {
  return rows(await postBiz({
    s: SERVICE,
    a: 'find',
    lsi: normalizeLoadSessionId(params.loadSessionId),
    imi: normalizeImportId(params.importId),
    iti: normalizeImportItemId(params.importItemId),
    dri: params.driverId ?? null,
    ssc: params.stateCode || null,
    pos: params.pageOffset ?? 0,
    plm: params.pageLimit ?? 100,
  })) as IBieGovernanceDecision[];
}
